module.exports = "/_next/static/images/Belanja_di_Toko_Mini_Web-Banner-c028ff384e479c133e2ef007c70453d4.jpg";